// Bootstrap Collapse already supplies the accordion, ARIA state, and height animation.
if (!customElements.get('speakon-home-faq')) {
  customElements.define('speakon-home-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        if (event.target.closest('.speakon-home-faq__toggle')) {
          this.toggleAttribute('data-instant-motion', event.detail === 0);
        }
      }, options);
      const resetMotion = () => {
        if (!this.querySelector('.collapsing')) this.removeAttribute('data-instant-motion');
      };
      this.addEventListener('shown.bs.collapse', resetMotion, options);
      this.addEventListener('hidden.bs.collapse', resetMotion, options);
      this.addEventListener('shopify:block:select', event => {
        const button = event.target.closest('[data-home-faq-item]')?.querySelector('button');
        if (button?.getAttribute('aria-expanded') === 'false') button.click();
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
